/**
 * This is a hard-code flow of colours that must be adhered to in order to achieve successful masking
 */
export enum ColourNamesPrimary {
  red = 'red',
  green = 'green',
  blue = 'blue'
}
export enum ColourNamesExt {
  yellow = 'yellow',
  magenta = 'magenta',
  aqua = 'aqua',
  white = 'white',
  black = 'black'
}

export type ColourArrayByName = { [colour: string]: number[] };

export const maskRegionBaseColours: ColourArrayByName = {
  [ColourNamesPrimary.red]: [1.0, 0, 0],
  [ColourNamesPrimary.green]: [0, 1.0, 0],
  [ColourNamesPrimary.blue]: [0, 0, 1.0]
};

export const maskRegionExtColours: ColourArrayByName = {
  ...maskRegionBaseColours,
  [ColourNamesExt.yellow]: [1.0, 1.0, 0],
  [ColourNamesExt.magenta]: [1.0, 0, 1.0],
  [ColourNamesExt.aqua]: [0, 1.0, 1.0],
  [ColourNamesExt.white]: [1.0, 1.0, 1.0],
  [ColourNamesExt.black]: [0, 0, 0]
};

export const maskRegionGlslVec3PropString: { [colour: string]: string } = {
  [ColourNamesPrimary.red]: 'r',
  [ColourNamesPrimary.green]: 'g',
  [ColourNamesPrimary.blue]: 'b'
};
